/**
 * ChannelFilterPressContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled channel filter press container.
 */
const ChannelFilterPressContainer = styled.div`
  align-items: center;
  border-radius: ${15 * Screen.widthRatio}px;
  border: 2px #e0e0e0 solid;
  background: rgba(217, 217, 217, 0.2);
  color: white;
  display: flex;
  flex-direction: row;
  font-family: Roboto;
  font-size: ${32 * Screen.widthRatio}px;
  height: ${66 * Screen.widthRatio}px;
  margin-left: ${12 * Screen.widthRatio}px;
  padding: ${0 * Screen.widthRatio}px ${20 * Screen.widthRatio}px;
`;

export default ChannelFilterPressContainer;
